export default __webpack_public_path__ + "static/membership-page-preview-section-bg-a6a088d8771156624af8e063cc4e8deb.jpg";